var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1667 1667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1410.17,3.833l-1154.11,0c-0.075,0 -0.149,-0 -0.223,-0c-34.378,-0 -62.667,28.289 -62.667,62.667c0,0.055 0.001,0.111 0.001,0.167l-0,1154.61c0.06,34.467 28.421,62.803 62.889,62.833l1154.56,0c34.467,-0.03 62.828,-28.366 62.889,-62.833l0,-1154.61c-0.303,-34.543 -28.789,-62.805 -63.333,-62.834Zm14.666,1197.72c0,0.018 0,0.037 0,0.055c0,18.591 -15.298,33.889 -33.889,33.889c-0.018,0 -0.037,0 -0.055,0l-1115.61,0c-0.019,0 -0.037,0 -0.056,0c-18.591,0 -33.889,-15.298 -33.889,-33.889c0,-0.018 0,-0.037 0,-0.055l0,-1115.61c0,-0.018 0,-0.037 0,-0.055c0,-18.591 15.298,-33.889 33.889,-33.889c0.019,-0 0.037,-0 0.056,0l1115.61,0c0.037,-0 0.074,-0 0.111,-0c18.561,-0 33.834,15.273 33.834,33.833c-0,0.037 -0.001,0.074 -0.001,0.111l0,1115.61Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "IconCircleOutline",
    d: "M357.889,1367.17c-71.607,0.152 -130.445,59.114 -130.445,130.722c0,71.712 59.011,130.722 130.723,130.722c71.712,-0 130.722,-59.01 130.722,-130.722c0,-0.111 0,-0.223 0,-0.334c0,-71.529 -58.859,-130.389 -130.389,-130.389c-0.111,0 -0.222,0 -0.333,0.001l-0.278,-0Z",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "PhoneIcon",
    d: "M414.278,1414.39l-0,165.167c-0.031,10.289 -8.488,18.747 -18.778,18.777l-81.222,0c-10.29,-0.03 -18.748,-8.488 -18.778,-18.777l0,-165.167c0.03,-10.29 8.488,-18.748 18.778,-18.778l81.222,0c10.211,0.234 18.544,8.567 18.778,18.778Zm-83.945,0.944c-0.001,4.723 3.834,8.632 8.556,8.723l31.222,-0c4.764,-0.031 8.667,-3.959 8.667,-8.723c-0.142,-4.708 -3.959,-8.55 -8.667,-8.722l-30.611,0c-0.111,-0.004 -0.223,-0.006 -0.334,-0.006c-4.806,-0 -8.776,3.922 -8.833,8.728Zm69.667,21.556l-91.278,-0.945l0,122.223l91.278,-0l0,-121.278Zm-57.778,141.278c0,6.796 5.593,12.389 12.389,12.389c6.796,-0 12.389,-5.593 12.389,-12.389c0,-6.797 -5.593,-12.389 -12.389,-12.389c0,-0 0,-0 -0,-0c-6.766,-0 -12.333,5.567 -12.333,12.333c-0,0.019 -0,0.037 -0,0.056l-0.056,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "PhoneIconBlack",
    d: "M414.278,1414.39l-0,165.167c-0.031,10.289 -8.488,18.747 -18.778,18.777l-81.222,0c-10.29,-0.03 -18.748,-8.488 -18.778,-18.777l0,-165.167c0.03,-10.29 8.488,-18.748 18.778,-18.778l81.222,0c10.211,0.234 18.544,8.567 18.778,18.778Zm-83.945,0.944c-0.001,4.723 3.834,8.632 8.556,8.723l31.222,-0c4.764,-0.031 8.667,-3.959 8.667,-8.723c-0.142,-4.708 -3.959,-8.55 -8.667,-8.722l-30.611,0c-0.111,-0.004 -0.223,-0.006 -0.334,-0.006c-4.806,-0 -8.776,3.922 -8.833,8.728Zm69.667,21.556l-91.278,-0.945l0,122.223l91.278,-0l0,-121.278Zm-57.778,141.278c0,6.796 5.593,12.389 12.389,12.389c6.796,-0 12.389,-5.593 12.389,-12.389c0,-6.797 -5.593,-12.389 -12.389,-12.389c0,-0 0,-0 -0,-0c-6.766,-0 -12.333,5.567 -12.333,12.333c-0,0.019 -0,0.037 -0,0.056l-0.056,-0Z",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.33,1333.33l-950.444,0c-90.455,0 -164.889,74.434 -164.889,164.889c-0,90.456 74.434,164.889 164.889,164.889l950,0c0.074,0 0.148,0 0.222,0c90.456,0 164.889,-74.433 164.889,-164.889c0,-90.371 -74.295,-164.767 -164.667,-164.889Zm-950.444,295.278c-71.607,-0.152 -130.445,-59.115 -130.445,-130.722c0,-71.712 59.011,-130.722 130.723,-130.722c71.712,-0 130.722,59.01 130.722,130.722c0,0.111 0,0.223 0,0.335c0,71.529 -58.859,130.389 -130.389,130.389c-0.203,-0 -0.407,-0.001 -0.611,-0.002Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 241.194,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 317.528,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0,
    y: 0,
    width: "250px",
    height: "290px",
    transform: "matrix(1.0076,0,0,1.01339,704.883,495.003)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M763.498,1509.49c-2.141,3.067 -5.128,5.36 -8.962,6.879c-3.834,1.519 -8.298,2.279 -13.39,2.279c-5.151,-0 -9.722,-1.208 -13.715,-3.624c-3.994,-2.416 -7.082,-5.852 -9.267,-10.308c-2.185,-4.456 -3.306,-9.621 -3.364,-15.495l0,-5.512c0,-9.52 2.221,-16.899 6.663,-22.136c4.441,-5.237 10.684,-7.856 18.728,-7.856c6.597,0 11.907,1.686 15.929,5.057c4.022,3.371 6.481,8.152 7.378,14.344l-8.333,0c-1.563,-8.362 -6.539,-12.543 -14.931,-12.543c-5.584,-0 -9.816,1.96 -12.695,5.881c-2.879,3.921 -4.333,9.599 -4.362,17.036l0,5.165c0,7.089 1.62,12.724 4.861,16.905c3.241,4.181 7.625,6.272 13.151,6.272c3.125,-0 5.86,-0.348 8.203,-1.042c2.344,-0.695 4.283,-1.866 5.816,-3.516l0,-14.192l-14.626,-0l-0,-6.771l22.916,-0l0,23.177Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.002,1493.86c-0,-4.601 0.904,-8.739 2.712,-12.413c1.809,-3.675 4.326,-6.511 7.552,-8.507c3.227,-1.997 6.909,-2.995 11.046,-2.995c6.395,-0 11.567,2.213 15.517,6.641c3.95,4.427 5.924,10.315 5.924,17.664l0,0.565c0,4.571 -0.875,8.673 -2.625,12.304c-1.751,3.632 -4.254,6.46 -7.509,8.486c-3.255,2.025 -6.995,3.038 -11.22,3.038c-6.365,-0 -11.523,-2.214 -15.473,-6.641c-3.949,-4.427 -5.924,-10.286 -5.924,-17.578l-0,-0.564Zm8.073,0.955c-0,5.208 1.208,9.389 3.624,12.543c2.416,3.154 5.649,4.731 9.7,4.731c4.08,0 7.321,-1.599 9.723,-4.796c2.401,-3.197 3.602,-7.675 3.602,-13.433c-0,-5.151 -1.223,-9.325 -3.668,-12.522c-2.445,-3.197 -5.693,-4.796 -9.744,-4.796c-3.964,0 -7.161,1.577 -9.592,4.731c-2.43,3.154 -3.645,7.668 -3.645,13.542Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.696,1493.86c0,-4.601 0.904,-8.739 2.713,-12.413c1.808,-3.675 4.326,-6.511 7.552,-8.507c3.226,-1.997 6.908,-2.995 11.046,-2.995c6.395,-0 11.567,2.213 15.516,6.641c3.95,4.427 5.925,10.315 5.925,17.664l-0,0.565c-0,4.571 -0.875,8.673 -2.626,12.304c-1.751,3.632 -4.253,6.46 -7.509,8.486c-3.255,2.025 -6.995,3.038 -11.219,3.038c-6.366,-0 -11.524,-2.214 -15.473,-6.641c-3.95,-4.427 -5.925,-10.286 -5.925,-17.578l0,-0.564Zm8.073,0.955c0,5.208 1.208,9.389 3.624,12.543c2.416,3.154 5.65,4.731 9.701,4.731c4.08,0 7.32,-1.599 9.722,-4.796c2.402,-3.197 3.602,-7.675 3.602,-13.433c0,-5.151 -1.222,-9.325 -3.667,-12.522c-2.445,-3.197 -5.693,-4.796 -9.744,-4.796c-3.964,0 -7.162,1.577 -9.592,4.731c-2.431,3.154 -3.646,7.668 -3.646,13.542Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.608,1493.91c-0,-7.32 1.692,-13.144 5.078,-17.469c3.385,-4.326 7.87,-6.489 13.455,-6.489c5.729,-0 10.199,2.025 13.411,6.076l0.391,-5.208l7.335,-0l-0,45.833c-0,6.077 -1.801,10.865 -5.404,14.367c-3.602,3.501 -8.442,5.251 -14.518,5.251c-3.386,0 -6.699,-0.723 -9.939,-2.17c-3.241,-1.447 -5.715,-3.429 -7.422,-5.946l4.166,-4.818c3.444,4.254 7.654,6.381 12.631,6.381c3.906,-0 6.951,-1.1 9.136,-3.299c2.185,-2.199 3.277,-5.295 3.277,-9.288l-0,-4.037c-3.212,3.704 -7.596,5.556 -13.151,5.556c-5.498,-0 -9.947,-2.214 -13.347,-6.641c-3.399,-4.427 -5.099,-10.46 -5.099,-18.099Zm8.073,0.912c-0,5.295 1.085,9.454 3.255,12.478c2.17,3.024 5.208,4.536 9.114,4.536c5.064,-0 8.782,-2.301 11.155,-6.901l-0,-21.441c-2.46,-4.485 -6.149,-6.728 -11.068,-6.728c-3.906,0 -6.959,1.519 -9.158,4.557c-2.199,3.039 -3.298,7.538 -3.298,13.499Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 928.082,
    y: 1451.11,
    width: 8.03,
    height: 66.667,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.446,1518.65c-6.366,-0 -11.545,-2.091 -15.538,-6.272c-3.993,-4.181 -5.99,-9.773 -5.99,-16.775l0,-1.476c0,-4.658 0.89,-8.818 2.67,-12.478c1.779,-3.66 4.268,-6.525 7.465,-8.594c3.197,-2.069 6.662,-3.103 10.395,-3.103c6.105,-0 10.851,2.011 14.236,6.033c3.385,4.022 5.078,9.78 5.078,17.274l0,3.342l-31.814,0c0.116,4.63 1.468,8.37 4.058,11.22c2.59,2.85 5.881,4.275 9.874,4.275c2.836,0 5.237,-0.579 7.205,-1.736c1.968,-1.158 3.689,-2.691 5.165,-4.601l4.905,3.82c-3.936,6.047 -9.838,9.071 -17.709,9.071Zm-0.998,-42.101c-3.241,0 -5.961,1.179 -8.16,3.537c-2.199,2.359 -3.559,5.665 -4.08,9.918l23.525,0l-0,-0.608c-0.232,-4.079 -1.331,-7.241 -3.299,-9.483c-1.968,-2.243 -4.63,-3.364 -7.986,-3.364Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1027.65,1493.04l-0,24.74l-8.334,-0l0,-63.195l23.308,0c6.915,0 12.333,1.765 16.254,5.295c3.921,3.531 5.881,8.204 5.881,14.02c-0,6.134 -1.917,10.857 -5.751,14.171c-3.834,3.313 -9.324,4.969 -16.471,4.969l-14.887,0Zm-0,-6.814l14.974,-0c4.456,-0 7.87,-1.049 10.243,-3.147c2.372,-2.098 3.559,-5.129 3.559,-9.093c-0,-3.761 -1.187,-6.77 -3.559,-9.027c-2.373,-2.257 -5.628,-3.429 -9.766,-3.516l-15.451,-0l-0,24.783Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1074.83,
    y: 1451.11,
    width: 8.03,
    height: 66.667,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.7,1517.78c-0.463,-0.926 -0.839,-2.575 -1.128,-4.948c-3.733,3.877 -8.189,5.816 -13.368,5.816c-4.63,-0 -8.428,-1.309 -11.394,-3.928c-2.965,-2.619 -4.448,-5.939 -4.448,-9.961c-0,-4.89 1.859,-8.688 5.577,-11.393c3.718,-2.706 8.948,-4.058 15.69,-4.058l7.813,-0l-0.001,-3.69c0,-2.806 -0.839,-5.042 -2.517,-6.705c-1.678,-1.664 -4.152,-2.496 -7.422,-2.496c-2.864,-0 -5.266,0.723 -7.205,2.17c-1.938,1.447 -2.908,3.197 -2.908,5.252l-8.073,-0c0,-2.344 0.832,-4.608 2.496,-6.793c1.664,-2.184 3.921,-3.913 6.771,-5.186c2.85,-1.274 5.982,-1.91 9.397,-1.91c5.411,-0 9.65,1.353 12.717,4.058c3.067,2.706 4.658,6.431 4.774,11.176l0,21.615c0,4.311 0.55,7.74 1.649,10.286l0,0.695l-8.42,-0Zm-13.324,-6.12c2.517,-0 4.904,-0.651 7.161,-1.953c2.257,-1.302 3.892,-2.995 4.905,-5.078l-0,-9.636l-6.294,0c-9.838,0 -14.757,2.879 -14.757,8.637c0,2.518 0.839,4.485 2.518,5.903c1.678,1.418 3.833,2.127 6.467,2.127Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.77,1506.02l10.938,-35.2l8.594,-0l-18.881,54.21c-2.922,7.813 -7.566,11.719 -13.932,11.719l-1.519,-0.13l-2.995,-0.565l0,-6.51l2.17,0.174c2.72,-0 4.84,-0.55 6.359,-1.65c1.519,-1.099 2.77,-3.11 3.754,-6.033l1.78,-4.774l-16.754,-46.441l8.768,-0l11.718,35.2Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "250px",
    height: "290px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAEiCAYAAADQ9s/LAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAgAElEQVR4nO2deZgU1dX/z63qqu7ZF2YYBGVmWAyIPMqwGFQ2fxmDG+CC5nWJD4pGzYsLRowLhvyiiZGQENC8QQzI8OaH7xhjFEWJvqwKPizKPgiIIIgIwsAwW3ct5/cHc9vqnl5qurv6dvecz/PcZximuutU1f3Wuffce88FIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCI4s2IN1ARE9OTk5NQUHBhQ899NC6d955xxRtU2di3rx5SmFh4dQbbrjBt2rVqiOi7SEylCeffHIOACAAoNvt3jJv3jxFtE2dhdraWllV1Q3Qdv8ffvjhCsEmEZnKgAEDPgQA9Hg8CABYXl7+BiIy0XZ1Bvr27TubMYaSJCEAYH5+/hTRNhEZSnV19VQAQEVRUJZlBAB86qmnbhFtV6Yzffr0wQDgFzkAYElJyf8VbBaRqSxZsqQC2ioaYwwZY5ifn4/btm0rEmxaxoKISnl5eQO03XdVVVGWZRw7duztom0jMhREZNdcc80BaBO6LMsoSRLee++9q6gJ7wz333//c4wxVBTF780BAF977bXegk0jMplly5ZdwZvtvPIVFBTgmjVrRom2LdPYtWvXOQUFBShJEsqy7O8u3XXXXQ2IKIm2j8hgEFEaP378CbA04QEAR48e3YCIFIVPEIjIHn744Y94qwna7ndhYSFu3LhxnGj7iE7AJ598Ut2lSxd/P51XxLfeeutR0bZlCuvXr78kPz/f3z3i9/jWW2/9irw5kRQQUbr33nu/AoCAJmV1dTUiYoFo+9IdRJSvu+66b8ESfJMkCQcMGIBHjx4dKNo+ohPx2WefDS0tLfU3Kbl3f+mllxaLti3dWb58+S2SJPm7RfxF+sILL7wr2jaik4GIbMaMGRugrSLyStmrVy88cuRIT9H2pSuI6B41apQP2oKdvMleUlKCn3/+eYlo+4hOyDfffFNRWVkZEIGXZRl/97vfraPhtthYuHDhk9A2OUZRFH9L6eWXX/6NaNuITszMmTMXQ1vznc+YKy8vx7q6usGibUs3Tp48WTBkyBD/cJrb7UbGGA4fPtxARI9o+4hOzMmTJwsGDRrk9+a8GT916lSKDneQuXPnLgLLfeSlpqbmVtG2EQTMmzdvWnDgqKioCLdv336taNvShe3bt59XUFDgj3XwnxMnTjyOiLSkOg6oD5kgEFEdNWpUw8cff+yWZRl8Ph8AANx0001Nr7/+ehFjTEuSHQwApG+++cYNANlHjhzJ9vl82Y2Njbler9fT2trq4pN6GGOaqqqaLMuthYWFjQUFBc1FRUXNPXr0aAYAH2PMSIbN3O7HH3987R/+8IfLGGNgGAYwxiA/Px9Wr1494uKLL/4oWbZkIiT0BLJ+/fobxowZ84bX6wWXywW6rgMiwtKlS++/7rrr/prIcyGi/NFHH+WfOHHi3O+++27Anj17qurq6i7XNO2S5uZm6cyZM3DixAk4c+YMtLa2gtfrDf48ICIAAMiyDG63GxRFgXPOOQdyc3OhuLgY8vLytK5du35SVla2try8fEtpaWldt27dDg0ePPgMYyyhCTe2bt1aVV1dvfnYsWMgy2edt2ma8B//8R/b//73v1/U5t0JQjyIKE+aNOk4X4DBo/A/+tGPEBGz4/hetnv37rx33nln8NNPP/3ouHHjtpx//vkBizysU0SthUes+ew93hwOPobPPLM2m0Md6/F4sHfv3njzzTdveu655x5auXLlxbt3786LZ4QBEaU777zzK75IiJ+3R48euGXLlvNj/V6CcIxPP/10ZEFBQYCIAAAXLlz4fEe+BxHdixcvrrrjjjt+M3z48BOlpaXo8XjaCVpVVb9ArX8LJVI7xfpCCH4BBItfURTMysrC7t2741VXXXX86aefnvGPf/xjECK6O3jPxuXn5/vPz19g06dPf68j30MQSQMR2dSpU/eBZRwYAHDgwIF4+vTp4kifO3jwYNH8+fPH33bbbWvOP/98f1APLEtiGWOoqqp/fBmCRB2LwEN59GjHKoqCqqr6WxPWacAXXXQRPvjgg2tqa2vHffnll4VR7pd63333NfPv4PerZ8+e+OWXX3aL6SEQRDI4ePDg4D59+vhFwEU6d+7cgKmxiOg+cuRIv3nz5j06atSob6zTacEirEgl+Phkl2j2devWDW+4/oYD//M//3NPc3Nzj+DhxldfffUX/Lv4HARZlvHZZ59dmKDHQRDOgIjsySef3ANBHvDCCy/EPXv2/EbTtD+uWLHiqwceeADLy8tt97FTUeh2iqqqqKoqDhs2DGfOnOn79NNP52iaNtzr9Q4YM2aMX9z8HowYMQIbGhpoqiuR+uzdu3d4165d/WLklXjgwIE4ZswYzMrKClh6ac1BZy3pLnS32x0QYAM4m6Rj3Lhx+JOf/MT/f7zJzhjDV199dWlinwZBOAQiyn/4wx/8lZf/DOe5I0XE01nowdcSfB/4y43/vPLKK/HkyZMjEvUciLO4RBuQwVxUUVEBAOAfrw7+txXTDD0sHe74dIRfi3UM3zRNYIz5r//uu++GoqIi2hSDSH00TRs7Z84cLCkpCenRqIRvsQwcOBDffvvtE4jYI45HQBDOgYiuf/3rX3NGjx7drkKHa7J39hKqKyJJEk6ePBl37NhxJy31JVKKvXv3Drj99tu/ta5Jh6AKDUkUULqUYKFbJ+eUlJTgU0899SEi5sT8YAgiESCiOmvWrLl9+/YVLpp0LHaCjZdeemnr8uXLaW0/IYYtW7acf8UVV9Rb0x1RSazQrcOPDzzwwAxa308kDURkL7/88n2lpaXtpn9SSazQrcfKsozDhg3bsHPnztyOPzWC6ACI6HrkkUdq+TxvKs4K3TqRiL9QS0tLWxcuXEgpnwln2LlzZ+6wYcN2AEDAohIqzgk/+O/WhJG33HLLZIrKEwmlpqama3l5+QmA9hF1KskTOi/8GVx22WWLKM0UkRDmzJnTW1VVHwAgNdnFC926waUsy9i7d+9N69aty7LzLAkiJI899tjFwWO8kAKCyNQSTei83x48b764uPj4vHnzaMUb0XEeffTRoZAClb8zlWjBuSgvgtY//vGPfaI/WYJo4+677x4GKVDxO1vpqNCDi9vtxgULFlTZeshE5+bWW28dRk309BQ6wNm++5w5c2ipKxGen//851WQAhW+s5ZECJ334xcvXkxiJ9rz2GOP9YYUqOyducQr9OBSW1s7LPqTJzoNL7zwQjcA8EEKVPbOXBIt9MLCQly6dGnfqBWAyHz+9Kc/FUqS1ED9cvEl0UIHAOzatavv448/7hq1IhCZy7Jly9z5+flf0xh5apRQ/e14Cp/gNGLEiOOHDh2iSTWdkdraWrmysnIdQGJnvPGsp4yxdv/mf+/My1olScKsrKyAe8XvSfDLNpHeffz48es66zLXTjtHGBHZ5MmT/7pjx47xsiyDrusJ+V5FUQK+S5IkUBQFevbsCWVlZcAYg6amJkBEYKzzrcdgjAEigq7roCgKlJWVQV5eHvh8PjAMo10yzHjvEf8+RVGgrq7uPK/Xq3/00Udr4vpSIn2YPHnyJIDv84knak251SOVlJTg448/jqtWrcKDBw/i119/jZ9//jnOmzcPR44cKdyziirZ2dl4zz334NKlS/HAgQP41Vdf4caNG/Evf/kLDhkyJKHePHg/OsYY1tTUDOlIXSHSlJqamv7BmwpY9/2Kp/CKNXjwYNy4cSPqmo6GYSCntbUVDcPA06dP4+TJk4WLLtmltLQU//Wvf/nvCf9pmiYiIjY1NeG9996bMKFbnwlf4tq3b1/f7t278zpab4g0YuvWrTkDBgxoBoB2u4QmKhjXvXt33LdvH9rBultJJhZrSyk3NxeXLVuGpmmiYRh+cVvhf5s2bVpAfCNRz4cviLniiitW0Fr2DAUR2dVXX70KIHALoEQL/S9/+QsiIuqaHlXo27Ztwy5duggXpFPFek+fffZZNE0Tm5ubQ4ocEdHr9SIi4vHjx/Hiiy925PlwD//iiy9ebafeEGnG4sWLJ/HK4pTQL7nkEjx9+nRAszQSpmnipEmTAipgJhXuzbt06YJ79+71e/JI94Yfc8sttzji0flz79Gjh7F161ZKJZ1JHD16tGu/fv3CBmgSVZHuuusu296c8+abb2Z81ppLL720nScP59X5/y9YsMBRjw4AOH78+DexEzThO8Xea4jI7r333rd3797Nf3fsXMXFxeDz+cDlsn9rCwsLweVygWEYjtklCkVRQNM06NKlC2RlBc5XCTV0Zt2D7pxzznHEJus5li5dOuHtt9++GAA+c+RkKUKnmDywatWqUa+99tolyTjXwYMHQVVVkCT7t3bp0qXg9XpBljNvWgMX8/79+6GxsTHq8ZIkgWEYwBiDNWsCh7udekE/88wz79TW1mbeze9MIKI8YcKEE8FNdl4S3TTs2bMnfv3117b654iIp06dwosuukh409rpUlJSgnv27LHdnWlpacHhw4cnvNkeXHgU/pFHHrk5amUiUpfa2tpbJUlCt9sdsh/sRB/woYceQtM0/RHkSPz2t79tFzfItMJ3spk+fXrU+6FrOpqmiYsWLQoY/nTKNkmSUJIkLC0tbd25c6catUIRqQciKldeeaXPOs88uDghdFVV8aWXXvJXXp/Ph4ZhoGEY2NraiohnI8srVqzAvLw8BMj8FNL8Gbzyyivo8/n8kXdd09tNKvrss8+wsrLS/zmnbVNVFSVJwgcffHBKhOpEpCpLliy51TrFNVSlcULojDHMzc3FmTNn4smTJ/2eikfi6+vrcfbs2VhaWhrwmUScO9VLdnY2zp07F5uamhCxfeR91apV2K9fPwSAhMxUjFasLanc3FxcuXKlJ3RtSm8ydlgBEeXRo0efWbt2bZY1yhpMcOQX4wz48CAcXyhzwQUXQFVVFXTt2hVUVYUTJ07Ahg0bYOvWrf7jTdP0L3KJ9/ypDmMMGGMwYsQIGDVqFBQXF0N2djZ8/fXX8Nlnn8GKFSugsbHR/1ycvh/8nvPFSFOmTHl0zpw5f3T0pETieO+9937M+18QwWs64dEhyFuE6oMHn6uzeHQI8tRO98E7UhhjeN5552WkV8/I4TVEZP/85z9fMk0zYMw02d6SnxsR/f/mHo3/W5RtItE0DRhjAUOQ1vuSTPh5+bkPHToEH3zwwU+SbgjRcdavX1+RnZ1t+y3u9BCOyPOlehF9P0KteOvbt28zZth+bhnp0RcsWPDL5uZm0WYQNkDEgJIKHDhwIOvdd98dKdqORJJxQkdEZePGjT9jjGXkTDPCWRhjoGkavPnmm3NF20JEYM2aNcN44CsZwzNUMqvwwGlJSQlu2rTJmcn2Asg4l1dSUvLi+vXr+zHGMnKRCJEcmpuboWvXrsfXrFnzsWhbiCB27typVlVV+YM6FOyiEkvhLcIRI0Y0YoZkjc2Ii+B8++23fbdv3+4P6qRKcIdIL0zTBEmSYMeOHTl1dXXnibYnEWSU0Ldv335TotI2E50b0zShvr4ePv7442tF25IIMkboiMi2bdv2MHlxIpGsXr36EdE2EBaOHTuWO2jQIOH9OyqZVc4991zMhK2cMsaj79+/v9fnn38u2gwiwzh8+DAcOnSoXLQd8ZIxQq+rqxvT0tLSoRROBGGHdevWJSUNmZNkjCq2bNkynvrnhBPU1dWNE21DvGREFlhEZEOHDh0l2g4i85AkCQ4ePHiVaDviJSM8+uHDhz1ffPGF1BkSNxDJBRHh4MGDWYioiLYlHjJC6IcOHSr2er0kciLhSJIEx44dg8OHD6f1powZIfTGxsZSr9fbKVIxEcnFMAzwer2wb9++YtG2xENGCH3Pnj3nulwuEjnhCD6fD3bs2FEm2o54yAihnz59urfX66WhNSLhuN1uQETYvn17Wo+lZ4QympqaKgEC99QiiETA89sdPHiwQrQt8ZARQvd6vb0BQm/aRxDxwFNcNTc39xVtSzxkhNCbmpr6k8gJJzl58mR/0TbEQ0YIvaWlpVKSJPLoRMKxePQLRdsSD2kvdESUmpqaJL7biaIotoJysiyDqn6/px7PM84TSrrdbpAkyV9kWYZwLxOeiFJRFJBl2X9sqGLNI87PGenv1gSXsiyD2+32/y5JEiiKEvB3bl+kexAph7rVplD/H+76g+0PvtfW67Aew59X8GfC3ROrXdbnZb3+UCXc/eWfs36ftXBM08yZMWNG2uolbQ234OKRUUmSQNM0W0E5wzDA5/MFPHC+0QJjDLxeL/ANIBARDMPw/zsY/jld1/2f4SLlvwdvJsEJ/jv//nBi5Dbzz2qaFnBNwdl1QlV67qVC/c1qk/XlZr03Vru48Kz28+/mf+P3jttjPcb6meB7Gq5Yj7HmBeTXH+q4YPusx1h/GoYRUFRVBcYY6LoOEydOTNsp42lruAX3T3/6Uzh27BgAgP+hGIYBuq6H9ExW76vrOmiaBq2treDz+UBVVdB1HYqKikDXdfD5fKAoCni9XlAUBdxuN2iaBj6fDwzD8HsR/jM/Pz/g78Hi9vl8Ab9bWxUAZ5MSWlsEiOgXs6IokJWVBS0tLWCapn/ox+v1gizLkJOTA16vF3RdB0VR/PcgmOzsbP+5gjEMA/Ly8sDlckFzczNomuZvSbhcLmhsbPSLhF+/y+UCVVVBURRobW313zd+/1VVBVmW/YLKyckBAICmpibIyspqJ8Bgz20VrTXpJ79Pra2tAADg8Xj8z5SfPzhBqLVFxL/b5XKBpmngcrnaHa8oCjQ1NcHll18OXbt2dQNA4AMkCIIgCIJIGgkPU8+YMUMqLy/v+s4771x06tSpy1paWgb7fL5yAPC43e6jJSUl2/v06bNueNXwT2689cYvGWOUzZHoNCBi1ttvv91v2bJll3z77beXaZpW7vP5igHgqKqq+0pLSz8ZPnz45oEDB+679NJLW0Tb247333+/+LbbbptWWVnZLEkSyrIcMReXJEnYq1cvnDJlyl9Xr16dESl1CSIUiMhWrlx54bRp096tqqrya4Pnj5dluZ1e8vLysLq6esNLL710JSKKj6V98cUXBbfddttisBjMGEO3242yLCPfo5wXvmMlfxnIsoyqquKkSZPe2Lt3b77o6yGIRHLgwIFzJkyY8GlWVlbAjrGqqqKiKKiqaoAOFEXxi54f26NHj+a5c+feEs9mEjE33RGRzZ49+9Znn332v+vr6/1R4OCocvCwSfCQkXWcs6yszJw+ffpVP/vZz/7dETtWrFhhLlq0CADORkkbGxsBACA3NxcAwB8F13XdH/Hl6Lrebr/yUPuXc1pbW/3Rdx7ZBgDwer3Q0tICubm5AUNxwRs9Bt+P4Ki73RV42dnZ/oh8qGEi/tPlCnQGWVlZ/vuhaZo/As/xer0Bv/NRBoDvx7ytvwffI0VRQNM0f/Q/1P3WNM0/uhEcBY9Gbm4ueL1e/xx0HqUH+H6oz/r8eH10u92QlZUFOTk5cPLkSdA0DdxuN2RnZwfYy0cy+DPkIwdDhw6F22+/3bZeEJEtWLDgzqeeemrhiRMn/NdsHQ5tOy7g9+D7ya8PEWHs2LHrH3/88SvHjBnT2KGbFiuIqDz//PNvuN1uVFXV3wQB6Ph+16E8/DPPPDPH7v7UiMimTZuGjDFUFCXgnB05v50S7nO8pWL9f35cqNZMpPPbsdXutSWiBD/baPfPzv21fldH7n+0exftnvDnYPceQ1srFQCwV69e9t7AbXXyxRdfnON2u9vdx47qg39GVVVkjGGXLl0a1q5dW2TXFk6H2/5tIl//xBNPDOb/Z30LWd+wNr8v4N8ulwuee+65KT6fbxgijmSM2Rq35N9jnS3F38rBkzys5+QeL/jNGm7SjSRJ7Sa28HMoiuIftw41uyzU93Z0DT33OHziDLc/2iQhbgv3hOEm5ISymc++03U9oJXCWzOhnr91Ik3w9/Ox8HDHRMI6hm7F+jysv/P/s0744S0R64Sb4ElA/P7w52l3w05EZH/+859nTZs2bYrVi/Ntnjr6vLmd/HmfPHkyb9KkSfv27t1b2bdv34YOfZldEFH605/+tMEaTLC+qYI9Vyxex/qZBQsW7IgWiEBE9stf/tL/9u2oR4+18Ou1bs0cfO7gexGLRwxVonmljly7nfOH8nKhgq3BdSAe++3c+44cHxwAs15LKHut1wIA2LNnT1sKnT179i0ej8ffQg1VB+LRB+/DV1VV7Vm5cqUzQbqPP/74nmAxOVG4eEpKSnD16tV/jWQTIrKHH364ww+fChW7hTGGlZWVCFFYvnx512gvuUTYwuv59ddfPyuaTR0GEV1jx441kiV0Lvbq6mpExB4R7CKhU3G0MMaienREZDfeeOMnTgvdalNWVhYuXLhwYCS7Osy8efOqANo3j524AFmWA8T+j3/8Y24k20joVJwqvK736NEDIQILFy4cGByYdbLwQN+55557YtOmTVFTUdsel3vrrbfGAYCjCRh5QISvyuJDEXPnzn0gUzakJ9KTaPV+/vz5f3PaBmsQlQ8bHj58uHjbtm2/T9hJ8vPz9wCA42+sUEERAMAlS5Z0D2fbL37xi5CfpUIlEYUxhuXl5QhhqKur6+LxeJJmS3Cg8Ibrb0BEvCCcfQA2PXptba185syZvtalhk4R/P0ulwsYY/D++++ndSofInNZsmTJuNbW1naTn5yAL+W1DvGuWLkC1q5duzLS52wJfcOGDR4+/phseDKBDRs2DI5+NEEkFjtzQjZv3vwQgP2x9kTBhX7q1ClYtWpV10jH2hL6rl278njyhWTDL+bIkSNpv3UtkXkgovz5559fJOr8fNLRrl27Ih9n58u2bNlS4PV6282bTgZc6F6v94fhjpEkyQw304sg4oXPTgvFe++9l7Nv3z4AELuvwP79+yP+3ZbQs7OziwDEXIiqqjxdUHdEDKfk5LaZCKKN+vr6Ip6kU4Sj4S+ghobIs2FtCR0RC+M3KTasq7N+/etfh1zowhijLVoIR4gmXtmUuyTJlLBYh9vCYUvoPp+vECByCmGnUBTFn4mzvLw8XN/BpA0WCSeIVq88eZ5iPu9DRB3k3Ypoy33tdrqFeXSedhcAoLi4WAGA1hCHmQC0JRPhDJFWZHq93mKA71c1JhtuV7SIvy0X7Xa7CwAgbA5uJ7HePMMwwg1UamH+nyDiIlpdNwyjKB0cjC2he73efIDAdbrJwrrOvKmpKaTQZVmmPjohBMZYXjp0G2013V0uVx4ABMzGSSY8NqDreriOCAmdEIMJBaJNsIMtjy7Lcg6A+P3HJUkK6dERkYROOAJvwYYLRJtg5oT8Q4phd3hN+MW0pTAij06kFIyx7OhHiceW0BljwoUOAKDrekiPzhjT0iEgQmQepvm9R0/lOmirj46IWU4bYgfGWLioO3l0whF4TCpCt7Vj+aoFYXcGjMdRK6JgydgZUuiGYZgA0YdCCCLRqKqqAIire/y80dahpIXQLYRcJ8uH10johBNEmjuCiM4vQk8AdvvoattPZ60JfW7/vxExpNBVVaWmO+EYkeo9Yyz5SRpioENCTwFC3lRJknQA8uiEEPxt5lSuf3aH14QJ3dpskiQpZEfENE0z1D5nBJEowmVX8nq9aZG01K6RQrdttWwaGK6ZRE13QhSZI3RJkhQA8eOE4Tw6kNAJB4lS71NC6NG0abfpLn4jdvj+hRMCEjrhKKnc/7aD3WCcZPm3c9ZEQdO0kJ1wRVFoeI1whGj1PScnJ2JOOaexq0dbQjdNMyWGECK0LPSkGkJ0OsIJmW+rLLpbGw1bQjcMQ2g/hN9ExljEPjp5dCLZeL3eiBlokkVC+uimaaZEwAHC20t9dMJRws115ymcRAs9GnbXo0sAkacCJomQXQjKAks4RbSEqDk5OSZA8ndp6Sh2h9ectsMW1qBgECR0whGiOTazzdVnhEd3uVwSgPgMM4yxcFPfKBhHOAJPnxbO2WmaZjLGhOxi1BHSyqObphlO6OTRCceI5NUNwzAjvQhSBbvBOBkgJZonIYVOOeMIJ4lU7z0ejwkAUXdKcZpoXYzUfg21J2QwDmlcjXCYcN3WVHEy0VoUdoWeKuPo4V6taREQITIP0U4m0RlmAr5UIOE2WaRgHCGEVKl7ifLoKYGmaSFfW3wcPdyaYYKIB0QM6zG9Xq/QWZm8FZuQPrqmaQFfKgpEjBiMS4EWB5Fh8G3IIiQ1EerReewgIZss8maBqCEEy3lD3m2fz2cyxvwLDAgiiRgA4pygoihgZxzf1ii/x+MRmqaJv7XCTZjRdR2txxFEorDhMYVWOl3XeSr0iMfZctG6rgvbYNGKK8xri883TvVJC0T6Eq5uiQ7GWUakIh6XFsqwvGDCToEV/RIiOi1CV7NwTx6t25ryQre+qcI13RERRQcKiU6LDiC+jx5txCnlhW4lQoYZ6pwTjmBDwEI9ekL76HyIQXTzuLm5OaS9fL4xQSQaXvcjCN4ASP2hXbvJIVMiXY4kSbR6jUg6kRKuiA7G2cXuenRhQg86Z7iZcYbolxCRmfDhtXBDt6ZpGnYj3yKx7dEBUmL4Ktxcd/LohCNYdgkKd4jQCTN2sbsePeBnMrGeU9O0kPaqqoqISBNmiITDBRwu2CXLsmHZGzBpdnFcLle0KboAkGZRdwg/k48UTjhKOBHLkuzvo6dyQK5DTfcUIKTQETG1U3ASaQuv++E8pktx+aPuqdyitOvRU+UKwr1xtKRaQXQ6IjTLdYDU9uYA6dd0D2kvBeMIp4kwxTRzgnEpRLime2q/TomMRdM0v9BFrvCMht0+ekr0gRGRNnAgkko0T80YS4tuY4eyzot2nFL4jhIJnXCEaHVelmV/dqO0D8bJsmymQrMknEf3+XxGOiTRJ9KXcBlcWlpatIyZGWeappnKm8gxxhBAfIuDyDyi1al0CQTbErqqqqlyMeFmxqWKfUQGEslTI6LwRS121qHYEnp2dnZKC12/3UUAABKjSURBVEmSJHLlhNOE1EBGrV7TdV1YZNG6FrilpSXkMWYqR0GItIbXPa/XG/Lvoj263bhAWsyM402TcME2GkcnRCFJUuZ4dBCYpJ4v+m8TesgXjiRJRpQsIAThFCkxjp6QPjoipsTFQPiWhUlOnXCYkMNOopvudrE7YcYHIG6c0JKvLqTQedOdPDrhBJHmaCiKkhapxu2Oo6fEWytChJOCcYQjcBGHS6ecLlNg7fbRWx21wibhmkk0vEYkgZDOxDCMjBK6D0D8zLNwsQJKPEE4Dd9ROJiMirq73e5mpw2JBJ9n39raGrJl4XK5kOa5E07icrlCenSv16vxER8RMSJd10GW5cTsj26aZiuAGI/O+0Ztw2yhZy1QH51wiGh13uVy+ZJkSkgYY2AYBuTm5kY8zlbU3ev1NiXEqhiwNpmys7NDtiyoj04kgZDORAvXpk8x7E6BbRa1JZO1OYSIIZvueJak2UR0SsLNdRcqdEQEWZahsbEx4nF2m+6NooQUdN4zoY5xuc5m4kzlpbREehMuZ5yiKEKb7gBn673H44l4jN1g3GlJkoTlxOKBNsMwQr62JEkij044TUgv4vP5hDfdGWOgqmrEY2wJXVGUBoDwWTachu9Goev6qVB/54v/aWYckWgsdSpk093j8fg9eio7G7tz3U+bpiksJxa/2ZqmNYT6O7lzIgmEm34tPOqOiODzRTbD7uBzPcDZfkqyvaYkSf4XjCzLJ0Mdw1NJkUcnEo0lH1xIoZ85c0YTFagG+L4V0dwceaqLLaFLkhRSYMmkbalqxKY7QThIyDpWVFQkPBgHAIkJxhmGIVzoABBV6OTRiUTD6xQihhR6fX298AwzjDHIycmJeJzdDRzqE2JVnEiSFFHo1FUnnCLcePk333wjfEyXMZYYj15eXn6af2GyQUT/7Li+ffuGHEfXdZ0UTjhNSI8+Y8YMs6SkxCvLspB9BXj8qqKiIuJxtiwbNGjQGQAxQg/a0ypkdkgedSePTjhI2DjQBRdcsMEwDCH1j+8QU1lZGfE4W0J/5JFHWhljQobXTNMEwzCgpKTkyM033xyymURz3YkkELYvPnr06FVJtKMd2dnZMHTo0OWRjrHbR8eKior1It5Y3JsPGjTotXDH0Hp0IgmEFfqYMWNWKYoirEU59sdjYcSIEbdHOsZ2p2LMmDE1fLwwmU14fvOqq6v/GeEY8uiEI/D1Ey6XK6zQR44cuamqqippNkmSFKDBcePHTWeMfRfxM3a/fOzYscu5npKpK9M0YdSoUfDYY49tCXcMCZ1wmkh5ExljDTfffPPr4fLKOWCLf1p4ZWVl05133vn7aJ+xLfRdu3Yd/PGPf+x/ayTTq0+cOPFtxljYNfHURyecgtfzaAlSp06deteoUaMcD2JZXyaICFOnTh2X8KWyGzdurC4qKkIASFq55JJL8LvvvusRya6ampobAADbpsJSoZKw0uZEsLy8/COIwpo1ayYkwyZFURAA8Nprr30TERPvcRGR/fnPf35XVVVkjPlvglMXUlJSgp988skT0exavHjxBCftodJ5iyzLyBjDnj17roAoICKbNWvWHEmSQtbFWBxR8PdwbfTp06fh0KFDWdFsihlEdD3xxBOfcCMS7UWt3zl//vxX7LyxFi1aNJ6ETsWJYhH6+2ADRJQmTZq0FABQVdW466Qsy35xc2243W7fhx9+WGbHnrhARNf48ePf4ieP50LClaeeeuppu82SV199dRwJnYoTRZZlBAAsLy9fCjZBROn+++//r3jqI2OsXWmzpWH+/Pnn2rUlbhBRevTRR5/mRsR6QcGlZ8+evr/97W/DO2JLTU3NdSR0Kk4Ui9Bfhw6AiOz3v//9hO7du7f7ro4U3ipgjOE111yzaevWrZFXrzjFG2+8UXXhhRc2cJHxNw8XnqIo/heBVYjBopRlGceNG/fezp07I+etDcGiRYuu5eeGDt5IKlQiFV5PKyoq/h/EwGeffVZ47bXX/ndw3bT+bnWWVmHzc5eVlfmef/756xwJvHWEnTt3qg899NDjvXv3DrgI/gbjRvOXAP9/SZJQVVUcPnz4/vnz5w+O9UJqamquBiChU0l8sQj9bxAHb731VtnkyZOnl5eXt/LvDm4N898lSUJZlrGysvLAY489dvWmTZviHqBP6Bvi0KFDWXV1dTfW1tbO/N///d9uhw8fBp6Cis+oY4yB2+2GH/zgB3D55ZcvufHGG387evTonTxLTCwsXrx47B133PGeyEwfRGbCMxz16tXrr/v3778/3u9DRKmmpuacdevWXbRp06YfSpLUz+fz9QSABlVVj5WVlX0yZMiQLcOGDdt29dVXh0ydFgsJzfZ43nnntQDAfyPi3/fv35+/a9eu3k1NTf1Pnjx5bmtrq5KVlXWioqJif2lpad3gwYOPMMb0F198Me7zIiJS0gnCSUzTDLlysqO05U74uq0sC3XMO++8k4hTBeBIWtc273waAD5tK45imiaKWl1HZDaWFmJK7CgcKxmxMyHfqYW8OuEUiJgQjy6KjBA638CBhE44iNAdheMlI4ROWWAJp4m0qCodyAihUyopwiksed1J6KLx+XxoZzN4gugoll2CIm9XmuJkhNDbJuAQRMLhzkNRFBK6aCRJQtoymXACLnSPxxMy1Xi6kBFCV1WVgnGEI1iEnrBZaiLICKG73W5quhOOwLMQu1wu8uiiyc3NJaETjjJkyBDqo4vmBz/4AZ533nmizSAyENM0gTEG1113HU2YEU337t0x2pY0BBELiAiFhYXmVVddlRLbI8dKRghdUZSTo0aNErLJHZH5DBo06J/xLKNOBTJFGXsnTJjwdl5enmg7iAxk5MiR/yXaBqINRMz/6U9/KjwjCZXMKpWVlT5EdGQ5NxEja9asuZ3n3FJVVXgloZLeRZIkrK2tvRuI1AIRpfvuu28b5Y6jEmux5nEbPnx4IyImZ0M1omOcOnWq6Ic//KEBQMkiqXS88DqTlZWFK1euHA1E6vL+++8PcLvdJHQqMRVVVfHVV19dJDy9MhGd119/fXRhYWG7hxhqBwxrCT6eSmaX4BzqiqLgrFmzNiHi2bmvROrzyiuvXFZSUmJb5CT0zlm4yPPy8nD27NkfUr88Ddm8eXP/IUOGtAKAf9cYEjoVa2GM4aBBg3DTpk33I2KmzC3pfBw/fjzvP//zP9d4PB4SepoWp55Nt27dcObMmS988cUXBUCkP4jINm/efMVVV111Ijs7GwHa7/8WXJlkWfYfw/e85n06y+6Wwgvf5srOiyvSS856jaHOIer6rNcS/NNu4dscAQB6PJ7mPn36vPTzn//8kp07d6q2KlCa0+miiogob9mypWr58uUPrl+//vYdO3bAiRMn4PTp04CIIMsyBGerURQFNE0DSZIAEVMyN50kSSDLctRNLILXA/DrUhQFJEkCn88HkiSBJEnAt7jSNE3o5hh8WyQAgOzsbMjOzgaX6+xktWC7EBEkSdIURdkvy/IXuq7vBoA9FRUVewoLCw8OHTr06K9+9auWdJ+73lE6ndCtICL77rvvcvft29flyy+/PKexsbGbYRjdGhsby2RZLi0oKOiqado5uq53UxSlu2EYWR6PB5qaziYEzcnJgSVLlsAHH3wAAOAXRrLhIn/wwQdh5MiRAX9zu90Bv6tqoAMLFrqmacAY8wvd7XbDRx99BE888QQYhiFE8Pzlm5eXBwsWLPjNxRdf/FpjY2NzQUFBy+nTp71lZWW++vp6fefOncbEiRPNziZiIsEgIkNECRFdiKgiYvbMmTMDtroFAc12AMCioiJ0MpBUWFgo7Pr4ve3duzfW19cPcuoaMxmKMHaAtr6iyRjTGWM+xlizx+MBn8/n3yk22fCmuNNLdF0ul5DWirUbZZomeL1eLelGZAAk9DiRJMnflhUhBE3T/D9//etfJ/38ycDaJZJlmYQeAyT0OHG5XP6KKDpI96tf/cpRA0TvbccYg5aWFl2oEWkKCT1BiBK5oigBPzMR673Nzc0ljx4DtKA+TjwejyFyNhXvwxqG4ajH5WILPkeyX3CmadJOHTFAHj1OGhsbgTHmz/8tmIwcVrK+TEjosUFCjxNd11NJ6I4halTBel7GGHg8HuqjxwAJPU4URTEREXRdeP1zvO8qIg5hPScikkePERJ6msNnsQFAq2hbksGJEydon70YIKGnOXxYDxFbknEukSAi5OXlkUePAYq6pzl87jkiep08D5/7LgLreXVdJ48eA+TR4yclKp5pmp2i6e71elPifqcbJPQ48fl8wpu0AAButzut9wazQ3NzM1RUVJDQY4CEHid8XXQKiL1TePTNmzcLv9HpCAk9TjwejwlwVuiC54I76tFFjqNbOXPmDAk9BkjocaIoimiBczqFRz9+/DgJPQZI6HHCm+yitmzmLxmfz+do1D0VVucBAEycOFG8EWkICT1+TABxaaQ4iJjxwbg2SOgxQEKPn1SZwOGoRyfSGxJ6/Oip0KQFh4NxorDGP9oCnilxs9MNEnqcaJrmX80iMijn9Mw4UVjm8gNQqyVmSOhxwhhLiYwnqWJHomlbscZ/PSPSlnSGhB4/qTKslZFNdy7yNs9+WrA5aQsJPU4QMSWEzhhzulkrbOqpZQizQZQN6Q4JPU4YY82ibQAAcLlcTnt0YaMLfOiSMUZCjxESepwgYqNoGwA6xzi6YRjUdI8REnqcMMaaRNsAAMAYc1rownNlAcAp0QakKyT0OEFEfyRY5PBaJxE6efQYIaHHicfjaQQQv0zVNE2nhZ4Kw3fk0WOEhB4nPp+vASAltityWuipEAMgjx4jJPQ48Xq9pwDOrl4TvKjF6eE14bPSEJGEHiMk9DgxDMPfRxcpdEmSHM0Ci4jChxFpeC12SOhx4na7TwGcncElsvlumqbTWWCFCN0yhg4ej4c8eoyQ0OMnJSqfJEmOztBDRCGBMGsryefz0Vz3GCGhx09KCD0J6Z6FXacsy4CIAd0komOQ0OPENM2UGPKRZdnpnVqOO/z9UfF6vST0GCGhx0lZWdlpSZLAMAxhmxDKsgwul8vRPrTH4znq5PfboUuXLsIDgukKCT1Ohg4deqa4uFjotsmICKqqOi2Cr0W8yFRVBV3XQZIkcLlcju8vl6mQ0ONE07SmgoICMAxDSNRdlmVgjEG3bt0cnXOfnZ39lZPfHw7DMECSJDBNE1wul/Cx/HSFhB4nFRUV3m7dup0CEDOOzrsNN910k6NCHzp0qBChW9NM79ixIxWm4aYlJPQ4YYzhyJEjnwM4u5lDsjEMA2RZhsLCQkej7hdeeOFhgO/HtZOV552nksrPzz9CiSEJobz55psVAICyLCOczTue1NKzZ0/H18QjIisuLj4OAMgYwzbROV74Pb388ssXOX2NmQx59AQwYcKEg6NHj/7CksQwaTDGoLq6emESzoN33XXX05IkJXWvdB7kvP766z9IygkJIhILFiy4RJKkpHvzLl264OrVqwcm4xq3bt2ak5eXl9SWC2MM+/fvj0eOHClJxjUSREQQkV122WUbJElCVVUdFQNjDPlLZcqUKTsQMWnh/nvuuedxSZJQlmVHrpF3C6zdg9dff31Ksq6PIKKydu3aosrKSmSMoaIojok8KysLGWPYr18/PHbsWLdkXiMiuq644opvAJyLSVhFfs8997yZzBcZQdhi0aJFY7hXd6Ipz715WVkZfvjhh9XJvbqzrFy5slthYaEv1muIVlRVRQDAH/3oRx8hoiuJl0YQ9nnhhRcmgkMiUBQFi4qKcM2aNdOSeU3BrF279vyePXs68iIDABw0aNC/V65cSSInUps5c+ZcyT26LMvodrs75NGsw1fWPnmPHj1w5cqVk1OhObt69eq+/fv3b+RNbUVRUJZl20Nv/DhJklBRFP81XnnllTMRkUaEiPTg3//+d/fKysoD0FaZ7fRpeWUPFrosyzhmzJjWdevWXSrkYsJw9OjRnGuuueYTq2h5CXe91hcX/1zbi8K47bbb/o+4qyGIGEFE6e677/5JSUmJAUECDleCj+nfvz/OmjXr5S+//NIj5ioig4ispqbm8urq6uNZWVkdaqpzb37NNde88dZbb+UJugSCSAyI6HrmmWeqy8vLd0cTuyzLqCgKDh482Ldo0aIn6+vrCwWabhtElN99990h48ePf693796Yl5cX9sWWm5uLffr0wTvuuGPFhx9+eL5QwzsBwvt5nZGlS5dm19XV9du/f/+AhoaGwQ0NDeUAIBUUFDSde+65n1ZWVu6oqqrasmzZsmMzZswQtrlhPBw6dChr165dvffs2XOxrusXIWKFruuevLy873Jzc3f36tVrY//+/TcXFxenRIYegiAIgiAIgiAIgiCIZPD/AZjOPYDFauT1AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleQr);
export default __webpack_public_path__ + "static/media/googleQR.ba5ae42eeaf11c74001921bbbf3db08f.svg";
export { ForwardRef as ReactComponent };